import ApiService from "./api.service";
 
const SportTypeCategoryService = {
    GetAll(lang, agecategoryid, isSeasonDoc,agecategoryIdList, initiativtypeid, genderId, isonlineregistration){
        if (isSeasonDoc == null || isSeasonDoc === undefined) {
            isSeasonDoc = false;
          }
          if (initiativtypeid == null || initiativtypeid === undefined|| initiativtypeid === '') {
            initiativtypeid = 0;
          }
          if (isonlineregistration == null || isonlineregistration === undefined|| isonlineregistration === '') {
            isonlineregistration = false;
          }
        if(agecategoryIdList!=null && agecategoryIdList!='' && agecategoryIdList!=undefined){
          var agecategoryidlist = ''
          for(let i=0; i < agecategoryIdList.length; i++){
            agecategoryidlist += `agecategoryIdList=${agecategoryIdList[i]}&`
          }
          return ApiService.get(`/SportTypeCategory/GetAll?lang=${lang}&agecategoryid=${agecategoryid}&isSeasonDoc=${isSeasonDoc}&${agecategoryidlist}initiativtypeid=${initiativtypeid}&genderId=${genderId}&isonlineregistration=${isonlineregistration}`)
        }
        else{
          agecategoryIdList = null
          return ApiService.get(`/SportTypeCategory/GetAll?lang=${lang}&agecategoryid=${agecategoryid}&isSeasonDoc=${isSeasonDoc}&agecategoryIdList=${agecategoryIdList}&initiativtypeid=${initiativtypeid}&genderId=${genderId}&isonlineregistration=${isonlineregistration}`)
        }
       
    },
}
export default SportTypeCategoryService